import { buildExcelExportURL } from '@/util/api'; 

export default {
  appTitle: 'Recherche de demandes d\'aménagement',
  resultsTitle: 'Resultas',
  advSearchTitle: 'Recherche avancée',
  detailsTitle: 'Détails du demande d\'aménagement',
  feedbackTitle: 'Application Feedback',
  faqTitle: 'Foire aux questions',
  termsTitle: 'Conditions d\'utilisation',
  opensInNewWindow: 'Opens in a new window FR',
  switchLanguage: 'View in English',
  feedbackSurveyText: 'Sondage d’opinion',
  feedbackSurveyLink: 'https://s-ca.chkmkt.com/?e=204244&h=3E5C3B684B26E7C&l=fr',
  feedbackSurveyAriaLabel: 'Sondage d’opinion',
  oldWebsiteText: 'Recherche précédente de demande d’aménagement',
  oldWebsiteLink: 'https://app01.ottawa.ca/postingplans/home.jsf?lang=fr',
  oldWebsiteAriaLabel: 'Recherche précédente de demande d’aménagement',
  download: {
    text: 'Téléchargement de toutes les données relatives aux demandes d’aménagement',
    link: buildExcelExportURL(),
    title: 'Confirmer le téléchargement',
    message: 'Vous êtes sur le point de télécharger toutes les données relatives aux demandes d’aménagement en format Microsoft Excel. Pour poursuivre, veuillez cliquer sur « Oui ».',
    yes: 'Oui',
    no: 'Non',
  },
  header: {
    signInButton: 'Connexion',
    menuLinks: [
      {
        text: 'Emplois à la ville',
        href: 'https://ottawa.ca/fr/emplois-la-ville',
        active: false
      },
      {
        text: 'Inscription aux cours et aux activités de loisirs',
        href: 'https://apps102.ottawa.ca/Activities/ActivitiesAdvSearch.asp?SCheck=109982093&SDT=38804.5054050926&LanguageId=2&LanguageIndex=2',
        active: false
      },
      {
        text: 'Mon ServiceOttawa',
        href: 'https://myservice.ottawa.ca/profile/account/login?lang=fr',
        active: false
      },
    ],
  },
  breadcrumb: {
    home: 'Home',
    homeLink: 'https://ottawa.ca/fr',
    planAndDevelop: 'Urbanisme, aménagement et construction',
    planAndDevelopLink: 'https://ottawa.ca/fr/urbanisme-amenagement-et-construction',
    neighbour: 'Que se passe-t-il dans votre quartier?',
    neighbourLink: 'https://ottawa.ca/fr/urbanisme-amenagement-et-construction/que-se-passe-t-il-dans-votre-quartier',
    thisTool: 'Recherche de demandes d\'aménagement' 
  },
  footer: {
    navTitle: 'Footer links',
    contactUsText: 'Nous joindre',
    contactUsLink: 'https://ottawa.ca/fr/hotel-de-ville/votre-administration-municipale/pour-nous-joindre',
    disclaimerText: 'Avertissement',
    disclaimerLink: 'https://ottawa.ca/fr/avertissement',
    privacyText: 'Confidentialité',
    privacyLink: 'https://ottawa.ca/fr/hotel-de-ville/responsabilisation-et-transparence/cadre-de-responsabilisation/acces-linformation-la-protection-de-la-vie-privee/protection-de-la-vie-privee#confidentialite',
    accessibilityText: 'Accessibilité',
    accessibilityLink: 'https://ottawa.ca/fr/hotel-de-ville/services-accessibles',
    ottawaCaText: 'Visitez ottawa.ca',
    ottawaCaLink: 'https://ottawa.ca/fr'
  },
  search: {
    form: {
      textLabel: 'Recherche par adresse, numéro de demande ou service. Pour d\'autres options de recherche, ',
      linkLabel: 'veuillez consulter les FAQ.',
      buttonText: 'Recherche',
      streetNameText: 'Adresse de voirie', 
      wardText: 'Quartier', 
      applicationTypeText: 'Type de demande', 
      applicationNumberText: 'Numéro de demande', 
      keywordText: 'Mots clés',
      activeDevAppText: 'Applications actives uniquement',
      inactiveDevAppText: 'Applications Inactive uniquement',
      allDevAppText: 'Applications Active/Inactive',
      applicationStatus: 'État de la candidature',
      option: 'Terme de Recherche, Nom de Rue ou Numéro de Demande.',
      all: 'Tout',
      findWardText: 'Trouver un quartier',
      findWardLink: 'https://ottawa.ca/trouverunquartier',
      findWardAriaLabel: 'Trouver un quartier',
      linkIsExternal: '(le lien est externe)'
    },
    results: {
      loading: 'Chercher des résultats',
      searching: 'Recherche ...',
      header: 'Résultats',
      clearButtonText: 'Effacer tout',
      clearButtonAriaLabel: 'Clear the results of this search and return to the search form FR',
      moreButtonText: 'Plus info',
      moreButtonAriaLabel: 'Le numéro de demande _APP_NUM_ fournit plus de détails',
      closest: 'Demandes d\'aménagement les plus proches',
      appStatus: 'État de la candidature',
      addressFriendly: 'Adresse',
      addressFriendlyPlural: 'Adresses',
      applicationNumber: 'Demande d\'aménagement # ',
      applicationType: 'Type de demande',
      currentStatus: 'État d\'avancement',
      date: 'Date d\'état',
      wardPrefix: 'Quartier',
      canComment: '(Ouvert aux commentaires)',
      cannotComment: '(Fermé pour commentaires)',
      nextPage: 'Page suivante',
      previousPage: 'Page précédente',
      of: 'sur',
      ascending: 'Ascendante',
      descending: 'Descendante',
      relevance: 'Pertinence',
      noResults: 'Aucun résultat trouvé',
      orderBy: 'Trier par:'
    }
  },
  devapp: {
    details: {
      loading: 'Rechercher des details',
      header: 'Demande d\'aménagement # ',
      viewSearchButtonLabel: 'Retour à la Recherche',
      viewSearchButtonAriaLabel: 'Retourner aux résultats de la recherche',
      closeButtonLabel: 'Fermer',
      closeButtonAriaLabel: 'Effacer les détails et revenir au formulaire de recherche',
      feedbackButtonLabel: 'Envoyer des commentaires',
      feedbackButtonAriaLabel: 'Envoyer des commentaires au responsable du fichier',
      cancelButtonLabel: 'Annuler',
      cancelButtonAriaLabel: 'Annuler l\'envoi de commentaires',
      info: {
        heading: 'Détails',
        appNum: 'Demande no',
        appStatus: 'État de la candidature',
        receivedDate: 'Date de réception',
        address: 'Adresse',
        addressPlural: 'Adresses',
        ward: 'Quartier',
        appType: 'Demande',
        objStatus: 'Statut de l\'objet',
        circulationEnd: 'Chronologie des commentaires',
        circulationEndNote: 'Période de soumission des commentaires',
        statusDate: 'Date d\'état',
        description: 'La description',
      },
      fileLead: {
        heading: 'Responsable du dossier',
        name: 'Nom',
        phone: 'Téléphone',
        sendComments: 'Veuillez envoyer vos commentaires au responsable du dossier',
      },
      docs: {
        heading: 'Documents d\'aide',
        text: 'Les exigences en matière de documents à l\'appui diffèrent selon le type de demande et la complexité de la proposition. Ainsi, certaines propositions exigent la collecte d\'études et de plans tandis que d\'autres, non. Le besoin de documents à l\'appui est spécifiquement précisé aux demandeurs avant le dépôt d\'une demande. Lorsque cela était possible, un plan illustrant la proposition a été fourni. Si vous avez des questions concernant les documents à l\'appui, veuillez communiquer avec le responsable du dossier.',
        conditionsShort: 'Les rapports, les études et la documentation connexe qui suivent sont soumis à certaines conditions. (Cliquez pour lire davantage)',
        conditionsLong: 'Les rapports, les études et la documentation connexe étayant la présente demande sont disponibles dans la langue dans laquelle ils ont été soumis par le demandeur. Ce sont des documents PRÉLIMINAIRES qui n’ont pas reçu l’aval ou l’approbation de la Ville d\'Ottawa. Le personnel de la Ville et d\'autres organismes pertinents procèdent à leur examen technique. Ces documents peuvent faire l\'objet d\'importantes révisions. La Ville s’efforcera de publier sur ce site toute nouvelle information sur les demandes d\'aménagement dès qu’elle sera disponible. Toutefois, les utilisateurs doivent noter qu’il est possible que cette actualisation prenne un certain temps.<br><br>L\'information de ce site Web est fournie à titre indicatif uniquement. Ce site Web vise à permettre au public de consulter l\'information sur les demandes d\'aménagement soumises à la Ville d\'Ottawa. Cette dernière n’est pas l’auteure de l’intégralité de l’information qui y est affichée. Ainsi, la Ville d’Ottawa et son personnel ne peuvent garantir ou déclarer qu’elle est exacte, complète, actualisée ou sans erreur et qu’elle ne contient pas de virus ou d’éléments destructeurs. La Ville n\'assume aucune responsabilité quant aux erreurs, aux omissions, à la fiabilité ou à l’utilisation de l’information qui y est affichée. Vous utilisez ce site Web et son contenu à vos propres risques. La Ville ne peut aucunement être tenue responsable d’un dommage résultant de la consultation, de la mise à jour ou de l’utilisation de ce site Web.<br><br>Les utilisateurs doivent savoir que l\'utilisation des rapports, des études ou de la documentation peut faire l\'objet de restrictions en vertu de la Loi sur le droit d\'auteur ou de toute autre loi applicable.<br><br>Veuillez noter que les demandeurs d\'aménagement et les parties intéressées doivent communiquer avec le responsable du dossier pour confirmer l’état de la demande d\'aménagement. Les parties intéressées doivent communiquer avec la Ville par écrit à l\'aide du formulaire en ligne, par télécopieur ou par la poste si elles souhaitent que la Direction de la planification les avise de la tenue d’une réunion publique ou d\'une décision sur la demande d\'aménagement. ',
        count: 'pièce jointe',
        countPlural: 'pièces jointes'
      },
    }
  }
}
